<template>
  <div class="container">
    <!-- Search -->
    <div class="box search-box" v-if="searchSettings">
      <i class="fa fa-search search-icon"></i>
      <input type="text"
             class="input-default"
             placeholder="Zoeken"
             v-model="searchSettings.searchQuery"
             :class="{ loading: searchSettings.searchLoading }"
             @keyup="search">

      <button class="button button-lg right" @click="columnSelector = !columnSelector"><i class="fal fa-columns"></i></button>
    </div>
    <!-- /Search -->

    <!-- Select columns -->
    <transition name="fade">
      <div class="box shadow" v-if="columnSelector">
        <h3>Kolommen selecteren</h3>

        <div class="column-dragger">
          <div class="draggable">
            <h4>Actieve kolommen</h4>
            <draggable :list="tableSettings.activeColumns" group="columns" :sortable="false">
              <div v-for="(element, index) in tableSettings.activeColumns"
                   :key="index"
                   class="draggable-item-wrapper">
                <div class="draggable-item shadow" @click="minusClick(index)">
                  {{tableSettings.columns[element].heading}}

                  <div class="right pointer"><i class="fa fa-arrow-right color"></i></div>

                  <div class="right pointer color"
                       v-if="index !== (tableSettings.activeColumns.length - 1)"
                       @click.stop.prevent="moveDown(tableSettings.activeColumns, index)">
                    <i class="fa fa-arrow-down"></i>&nbsp;&nbsp;</div>

                  <div class="right pointer" v-if="index > 0"
                       @click.stop.prevent="moveUp(tableSettings.activeColumns, index)">
                    <i class="fa fa-arrow-up color"
                       >
                    </i>&nbsp;&nbsp;
                  </div>

                </div>
              </div>
            </draggable>
          </div><!--

            --><div class="draggable">
          <h4>Beschikbare kolommen</h4>
          <draggable :list="availableColumns" group="columns" :sortable="false">
            <div v-for="(element, index) in availableColumns"
                 :key="index"
                 class="draggable-item-wrapper">

              <div class="draggable-item shadow" @click="plusClick(index)">
                <i class="fa fa-arrow-left pointer color"></i> &nbsp;&nbsp;
                {{tableSettings.columns[element].heading}}
              </div>

            </div>
          </draggable>
        </div>
        </div>

        <button class="button right" @click="columnSelector = false"> Sluiten </button>
      </div>
    </transition>
    <!-- / Select columns -->

    <!-- Data table -->
    <div class="box shadow">
      <div class="data-table">

        <table>
          <thead>
          <tr>
            <td v-for="(columnIndex, index) in tableSettings.activeColumns" v-bind:key="index">
              {{ tableSettings.columns[columnIndex].heading }}
            </td>
          </tr>
          </thead>
          <tbody>
            <router-link  v-for="(item, index) in items"
                          v-bind:key="item._id"
                          class="data-table-row shadow clickable"
                          tag="tr"
                          v-bind:to="tableSettings.link(item)"
                          :key="index">
              <td v-for="(columnIndex, index) in tableSettings.activeColumns"
                  :key="index"
                  v-html="sanitizeValue(item[tableSettings.columns[columnIndex].value] ?
                              item[tableSettings.columns[columnIndex].value] : tableSettings.columns[columnIndex].value(item))">
              </td>
            </router-link>

            <tr v-if="items.length === 0">
              <td class="center" :colspan="tableSettings.activeColumns.length">{{ searchSettings.noneMessage }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable';

export default {
  data() {
    return {
      columnSelector: false,
    };
  },

  methods: {
    sanitizeValue(value) {
      return (value) ? this.sanitize(value) : '';
    },

    minusClick(index) {
      this.tableSettings.activeColumns.splice(index, 1);
    },

    plusClick(index) {
      this.tableSettings.activeColumns.push(this.availableColumns[index]);
    },

    moveUp(arr, old_index) {
      const new_index = old_index - 1;

      if (new_index >= arr.length) {
        let k = new_index - arr.length + 1;
        while (k--) {
          arr.push(undefined);
        }
      }
      arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
      return arr;
    },

    moveDown(arr, old_index) {
      const new_index = old_index + 1;

      if (new_index >= arr.length) {
        let k = new_index - arr.length + 1;
        while (k--) {
          arr.push(undefined);
        }
      }
      arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
      return arr;
    },

    search() {
      this.searchSettings.searchLoading = true;
      clearTimeout(this.searchTimeout);

      this.searchTimeout = setTimeout(() => {
        this.searchSettings.searchCallback(this.searchSettings.searchQuery);
      }, 250);
    },
  },

  props: ['tableSettings', 'items', 'searchSettings'],

  computed: {
    availableColumns() {
      const availableColumns = [];

      for(let i = 0; i < this.tableSettings.columns.length; i++) {
        if(this.tableSettings.activeColumns.indexOf(i) === -1) availableColumns.push(i);
      }

      return availableColumns;
    }
  },

  components: {
    draggable,
  },
};
</script>

<style scoped>
  .v--modal {
    height: auto !important;
  }

  .column-dragger * {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .draggable {
    display: inline-block;
    width: 50%;
    box-sizing: border-box;
    vertical-align: top;
    padding-bottom: 30px;
  }

  .draggable-item-wrapper {
    padding: 0 10px 10px 0;
    box-sizing: border-box;
    cursor: move;
  }

  .draggable-item {
    box-sizing: border-box;
    padding: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/DataTableVue.vue